import { createRouter, createWebHistory } from 'vue-router'
import * as utils from '@/utils'
import ROUTER_GUDU16 from '@/views/router_GUDU16.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: ROUTER_GUDU16,
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory('/pc1'),
  routes,
})

// 路由地址访问跳转
let isFirstVisit = true
router.beforeEach((to, from, next) => {
  if (isFirstVisit) {
    isFirstVisit = false
    if (to.path == '/') {
      let linkRouter = utils.getUrlParams('toRouter')
      if (linkRouter) {
        next({
          path: `/${linkRouter}`,
          query: utils.getUrlParamObj(),
        })
        return
      }
    }
  }
  next()
})

export default router
